
(function () {
    'use strict';

    angular.module(modules.homeModule)
           .controller('annualCycleController', controller);

    controller.$inject = ['$scope', '$http'];

    function controller($scope, $http) {

        var partitionings = [
                {
                    id: 1,
                    name: globalResources.Month
                },
                {
                    id: 2,
                    name: globalResources.Quarter
                },
                {
                    id: 3,
                    name: globalResources.Tertiary
                },
                {
                    id: 4,
                    name: globalResources.SchoolYear
                }
        ];
        var vm = this;
        vm.gridSettings = [
                { id: 'name', name: globalResources.Name, width: 15, coldefault: true },
            { id: 'description', name: globalResources.Description, width: 15, coldefault: true, customCss: 'ellipsis-span' },
                { id: 'year', name: globalResources.Period, width: 10, coldefault: true },
                { id: 'partitioning', name: globalResources.Partitioning, width: 10, coldefault: true }
        ];

        vm.identifier = 'gridSettings';
        vm.colCannotRemove = 'name';
        vm.alerts = [];
        vm.annualCycles = [];

        vm.clickRow = clickRow;

        vm.searchAnnualCycle = searchAnnualCycle;

        searchAnnualCycle();

        function searchAnnualCycle(keyword) {
            return $http.get('/api/annualCycle/getPaged', {
                params: {
                    keyword: keyword,
                    pageIndex: 0,
                    pageSize: 99999
                }
            }).then(function (response) {
                vm.annualCycles = [];
                if (response.data && response.data.data) {
                    response.data.data.forEach(function (ele) {
                        ele.id = ele.annualCycleId;
                        ele.partitioning = (partitionings.find(function (x) {
                            return x.id == ele.partitioning;
                        })).name;
                        ele.year = ele.year ? ele.year : globalResources.Recurring;
                        vm.annualCycles.push(ele);
                    });
                }

                $scope.$emit('annualCyclesLength', vm.annualCycles.length);
            });
        }

        function clickRow(id) {
            window.open('/annualCycle/' + id, "_blank");
        }

    }
})();

